// extracted by mini-css-extract-plugin
export var VisitSpecificCafe = "VisitSpecificCafe-module--VisitSpecificCafe--ef937";
export var image = "VisitSpecificCafe-module--image--145f7";
export var menuLink = "VisitSpecificCafe-module--menuLink--415b6";
export var textContent = "VisitSpecificCafe-module--textContent--2a315";